import {useEvent} from 'Event/EventProvider'
import {api} from 'lib/url'
import {DEFAULT_WIDGET_TEMPLATE, Widget} from 'Event/Widget/template'
import {useOrganization} from 'organization/OrganizationProvider'
import {useQuery} from 'react-query'

export function useWidget() {
  const {event} = useEvent()
  const {client} = useOrganization()

  return useQuery({
    queryKey: ['events', event.id, 'widgets'],
    queryFn: async () => {
      const data = await client.get<Widget>(api(`/events/${event.id}/widgets`))
      return {
        ...data,
        template: {
          ...DEFAULT_WIDGET_TEMPLATE,
          ...data.template,
        },
      }
    },
  })
}
